import http from 'axios';

/**
 * To make service API alls with AXIOS Library.
 */
class HttpServices {
  /**
   * To make service calls with http methods.
   * @param {*} urlEntity formed URL.
   * @param {*} headers consolidated Headers.
   * @param {*} method Http methods.
   * @param {*} data request data.
   * @param {strijg} key end point key.
   * @param {array} requests service requests collection.
   * @param {array} progress callback for monitoring the service progress.
   * @returns {promie} result of the Service API.
   */
  __request(
    urlEntity: string,
    headers: any,
    method: string,
    data: any,
    key: string,
    requests: any,
    progress: any
  ) {
    const _serviceUrl = urlEntity.toString();
    if (requests[key]) {
      requests[key].cancel();
    } else {
      requests[key] = http.CancelToken.source();
    }
    const values: any = {
      method,
      url: _serviceUrl,
      headers,
      data,
      onDownloadProgress: progress,
      onUploadProgress: progress,
      timeout: this.timeOut
    };
    return http(values);
  }

  /**
   * To make service calls with http methods for Rest API.
   * @param {*} urlEntity formed URL.
   * @param {*} headers consolidated Headers.
   * @param {*} method Http methods.
   * @param {*} data request data.
   */
  __requestRestApi(
    urlEntity: string,
    headers: any,
    method: string,
    data?: any
  ) {
    const _serviceUrl = urlEntity.toString();
    const values: any = {
      method,
      url: _serviceUrl,
      headers,
      data,
      timeout: this.timeOut
    };
    return http(values);
  }

  /**
  * To set timeout for request
  * @returns {number} specific time out based on end point key.
  */
  get timeOut(): number {
    let timeOut = 40;
    return timeOut * 1000;
  }

  __instance() {
    return http;
  }
}

export default HttpServices;
